var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"access-denied"},[_c('p',[_c('fa-icon',{attrs:{"icon":"lock"}})],1),_c('p',[_vm._v("You are not allowed to access this page.")])])}
var staticRenderFns = []

export { render, staticRenderFns }